import { ComponentInstall } from "../../utils";
import Radio from "./src";

export default ComponentInstall(Radio);
